import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import SubscribePage from '../pages/SubscribePage';
import LoginPage from '../pages/LoginPage';
import HomePage from '../pages/HomePage';
import SelectCaptainAndViceCaptain from '../pages/SelectCaptainAndViceCaptain';
import LiveMatches from '../pages/LiveMatches';
import MatchDetails from '../pages/MatchDetails';
import FantasyGame from '../pages/FantasyGame';
import CreateFantasyTeam from '../pages/CreateFantasyTeam';
import MyMatches from '../pages/MyMatches';
import CreatePrediction from '../pages/CreatePrediction';
import PredictionGame from '../pages/PredictionGame';
import Leaderboard from '../pages/Leaderboard';
import Profile from '../pages/Profile';
import Auth from '../component/Auth';
import EditProfile from '../pages/EditProfile';
import OtpPage from '../pages/OtpPage';
import SelectSubscription from '../pages/SelectSubscription';
import SelectPack from '../pages/SelectPack';
import SubscriptionProcessing from '../pages/SubscriptionProcessing';
import IntroPage from '../pages/IntroPage';

const Routing = () => {
    const router = createBrowserRouter([
         {
            path: "/",
            element: <IntroPage />
        },
        {
            path: "/sub",
            element: <SubscribePage />
        },
        {
            path: "/login",
            element: <LoginPage />
        },
        {
            path: "/otp",
            element: <OtpPage />
        },
        {
            path: "/select-subscription",
            element: <SelectSubscription />
        },
        {
            path: "/subscription-processing",
            element: <SubscriptionProcessing />
        },
        // {
        //     path:"/select-pack",
        //     element:<SelectPack />
        // },
        {
            path: "/home",
            element:
                <Auth>
                    <HomePage />
                </Auth>
        },
        {
            path: "/create-fantasy-team",
            element:
                <Auth>
                    <CreateFantasyTeam />
                </Auth>
        },
        {
            path: "/select-captains",
            element:
                <Auth>
                    <SelectCaptainAndViceCaptain />
                </Auth>
        },
        {
            path: "/fantasy-game",
            element:
                <Auth>
                    <FantasyGame />
                </Auth>
        },
        {
            path: "/live",
            element:
                <Auth>
                    <LiveMatches />
                </Auth>
        },
        {
            path: "/match-details",
            element:
                <Auth>
                    <MatchDetails />
                </Auth>
        },
        {
            path: "/my-matches",
            element:
                <Auth>
                    <MyMatches />
                </Auth>
        },
        // {
        //     path: "/create-prediction",
        //     element:
        //         <Auth>
        //             <CreatePrediction />
        //         </Auth>
        // },
        // {
        //     path: "/prediction-game",
        //     element:
        //         <Auth>
        //             <PredictionGame />
        //         </Auth>
        // },
        {
            path: "/leaderboard",
            element:
                <Auth>
                    <Leaderboard />
                </Auth>
        },
        {
            path: "/profile",
            element:
                <Auth>
                    <Profile />
                </Auth>
        },
        {
            path: "/edit-profile",
            element: <Auth>
                <EditProfile />
            </Auth>
        },
        {
            path:"/main",
            element:<IntroPage />
        },
        {
            path: "*",
            element: <Navigate to="/" />
        }

    ]);
    return (
        <RouterProvider router={router} />
    )
}

export default Routing